export const reservas = {
    // Filtro con el que llega el listado desde las cajas del dashboard
    filtroLlegadas: {
        today: `Anreise heute`,
        tomorrow: `Anreise morgen`,
        this_week: `Anreise diese Woche`,
        month: `Anreise diesen Monat`,
        upcoming: `Kommende Anreisen`,
    },
    filtroSalidas: {
        today: `Abreise heute`,
    },
    quitarFiltro: `Filter entfernen`,
    // Estancia vendida por horas registrada como reserva
    rapida: `Schnell`,
    p1:`Buchungsliste`,
    p2:`Liste der auf der Plattform erfassten Buchungen`,
    p3:`Weitere Aktionen`,
    p4:`Check-in planen`,
    p5:`Heute`,
    p6:`Buchungscode`,
    p7:`Vorname`,
    p8:`E-Mail`,
    p9:`Check-in-Datum`,
    p10:`Anzahlung`,
    p11:`Anzahl der Gäste`,
    p12:`Status: `,
    p13:`Betrag: `,
    p14:`Status: `,
    p15:`Ausstehend`,
    p16:`Abgeschlossen`,

    p17:`Weitere Aktionen`,
    p18:`Buchungen importieren`,
    p19:`Laden Sie eine Excel-Vorlage herunter, tragen Sie Ihre Buchungsdaten ein und laden Sie sie hoch, um mehrere Buchungen auf einmal anzulegen.`,

    p20:`Geplanter Check-in`,
    p21:`Detaillierte Informationen zum geplanten Check-in`,
    p22:`Status: `,
    p23:`Bezahlt`,
    p24:`Zahlung ausstehend`,
    p25:`Zahlungsstatus ändern`,
    p26:`Verantwortlich für den Check-in`,
    p27:`Online-Check-in senden`,
    p28:`Check-in-Link wird gesendet...`,
    p29:`Online-Check-in-Link automatisch an Gäste senden`,
    p30:`Eine Woche vor dem Check-in`,
    p31:`72 Stunden vor dem Check-in`,
    p32:`48 Stunden vor dem Check-in`,
    p33:`24 Stunden vor dem Check-in`,
    p34:`Änderungen speichern`,
    p35:`Check-in-Datum`,
    p36:`Check-out-Datum`,
    p37:`Erfasste Gäste`,
    p38:`Liste der abgeschlossenen Check-ins`,
    p39:`Vorname`,
    p41:`Nachname`,
    p42:`Check-in-Datum`,
    p43:`E-Mail`,
    p44:`Vorgang`,
    p45:`Gescannt`,
    p46:`Manuell`,
    p47:`Manuell (Mitarbeiter)`,
    p48:`Telefon`,
    p49:`Keine Check-ins erfasst`,

    p50:`Zahlungsstatus der Buchung`,
    p51:`Ändern Sie den Zahlungsstatus der Buchung manuell.`,
    p52:`Wählen Sie eine der Optionen`,
    p53:`Ausstehend`,
    p54:`Bezahlt`,
    p55:`Abbrechen`,
    p56:`Status ändern`,
    p57:`Nicht angegeben`,
    p58:`Abgeschlossen`,
    p59:`Noch keine Buchungen erfasst`,
    p60:`Geplante Check-ins`,
    p61:`Änderungen erfolgreich gespeichert`,
    p62:`Möchten Sie den Check-in-Link senden?`,
    p63:`Link senden`,
    p64:`Abbrechen`,
    p65:`Check-in-Anfrage erfolgreich gesendet`,

    p66:`Unterkunft oder Benutzer nicht gefunden.`,
    p67:`Fehler beim Erzeugen des Tokens`,
    p68:`Fehler bei der Verbindung mit dem Kanal. Bitte versuchen Sie es erneut.`,
    p69:`Verfügbarkeit & Raten`,
    p70:`Verwalten Sie verfügbare Tage und Raten Ihrer Unterkunft`,
    p71:`Für diese Funktion benötigen Sie einen aktiven Tarif. Dann sehen Sie die Verfügbarkeit Ihrer Unterkunft sofort, passen Raten an Saison oder besondere Anlässe an und verwalten alles an einem Ort.`,
    p72:`Wenn Sie diese Buchung stornieren, werden die Daten auf allen verbundenen Portalen wieder freigegeben`,
    p73:`Buchung stornieren`,
    p74:`Buchung erfolgreich storniert`,
    p75:`Buchung von `,
    p76:` storniert.`,
    p77:`An gesperrten Daten können Sie nicht buchen.`,
    p78:`Prüfen Sie die ausgewählten Daten`,
    p79:`Sie müssen mindestens eine Nacht für die Buchung auswählen.`,
    p80:`Die ausgewählten Daten sind nicht verfügbar.`,
    p81:`Erinnerungen`,
    p82:`Verwalten Sie die Erinnerungen für Ihre Gäste`,
    p83:`Neue Erinnerung erstellen`,
    p84:`Tag`,
    p85:`Uhrzeit`,
    p86:`Beschreibung`,
    p87:`Erinnerung löschen`,
    p88:`Keine Erinnerungen gefunden`,
    p89:`Möchten Sie die Erinnerung wirklich löschen?`,
    p90:`Gespeicherte Daten gehen verloren`,
    p91:`Erinnerung löschen`,
    p92:`Erinnerung erfolgreich gelöscht`,
    p93:`Erster Schritt:`,
    p94:`Wählen Sie das Land, in dem Sie Buchungen haben, und laden Sie die Vorlage herunter, um die Daten einzutragen.`,
    p95:`Vorlage herunterladen`,
    p96:`Zweiter Schritt:`,
    p97:`Laden Sie dieselbe(n) heruntergeladene(n) Vorlage(n) mit den ergänzten Daten hoch.`,
    p98:`Importieren`,
    p99:`Sie müssen die Vorlage hochladen, um mit dem Import fortzufahren`,
    p100:`Vorgang erfolgreich abgeschlossen`,
    p101:`Fehler beim Import`,
    p102:`Verfügbar`,
    p103:`Belegt`,
    p104:`Reinigung`,
    p105:`Wartung`,
    p106:`Fehler beim Stornieren der Buchung`,
    p107:`Fehler beim Aktualisieren der Ansicht nach der Stornierung`,
    p108:`Zimmerwechsel konnte nicht geöffnet werden. Ungültige Buchung.`,
    p109:`Das aktuelle Zimmer konnte nicht ermittelt werden.`,
    p110:`Verfügbarkeit erfolgreich aktualisiert`,
    p111:`Hotelkalender`,
    p112:`Verwalten Sie Ihre Buchungen visuell und behalten Sie die Verfügbarkeit Ihres Hotels voll im Griff.`,
    p113:`Verfügbarkeit ändern`,
    p114:`Buchung erstellen`,
    p115:`Pausierte Buchungen werden nicht automatisch gesendet`,
    p116:`Der automatische Versand wird für diese Buchung aktiviert`,
    p117:`Pausieren`,
    p118:`Aktivieren`,
    p119:`der Buchung`,
    p120:`Ja`,
    p121:`Buchung erfolgreich pausiert`,
    p122:`Vorgang erfolgreich abgeschlossen`,
    p123:`Buchung erfolgreich aktiviert`,
    p124:`Synchronisierte und manuell erstellte Buchungen`,
    p125:`Ungültiges Datum`,
    p126:`Ungültiges Datum`,
    p127:`Check-in-Einladung wird gesendet am `,
    p128:`Buchung pausiert`,
    p129:`Buchung storniert`,
    p130:`Abgeschlossen`,
    p131:`Hier erscheinen alle Ihre Buchungen mit den Details zu Check-in und Gast. Sobald Sie Ihre erste Buchung erhalten, sehen Sie sie genau hier.`,
    p132:`Ausgewählte Unterkunft`,
    p133:`Mehrere`,
    p134:`Monatlich`,
    p135:`Geschlossen`,
    p136:`Daten erfolgreich aktualisiert`,
    p137:`Fehler beim Laden der Unterkunftsdaten`,
    p138:`Die ausgewählten Daten sind nicht verfügbar. Es gibt Buchungen oder geschlossene Daten, die zu einem Konflikt führen.`,
    p139:`Buchung erfolgreich erstellt`,
    p140:`Zeitraum`,
    p141:`erfolgreich geschlossen`,
    p142:`Fehler beim Sperren der Daten`,
    p143:`Fehler beim Aufheben der geschlossenen Daten`,
    p144:`Preise erfolgreich aktualisiert`,
    p145:`Fehler beim Aktualisieren der Preise`,
    p146:`Möchten Sie diese Buchung wirklich stornieren?`,
    p147:`Stornierung bestätigen`,
    p148:`Ja, stornieren`,
    p149:`Nein`,
    p150:`Buchung erfolgreich storniert`,
    p151:`Fehler beim Laden der Unterkünfte`,
    p152:`Neue Buchung zum Kalender hinzugefügt`,
    p153:`Diese Buchung stammt aus einem externen Kanal (OTA). Es wird nicht empfohlen, sie direkt in diesem System zu stornieren. Bitte wenden Sie sich an den Gast und bitten Sie ihn, die Buchung über den ursprünglichen Kanal zu stornieren.`,
    p154:`OTA-Buchung, Stornierung nicht möglich`,
    p155:`Verstanden`,
    p156:`Fehler bei der Verarbeitung der Anfrage`,
    p157:`Link erfolgreich kopiert`,
    p158:`Kopiert!`,
    p159:`Beim Kopieren des Links ist ein Fehler aufgetreten`,
    p160:`Fehler`,
    p161:`Check-in an den Buchungsverantwortlichen senden`,
    p162:`Check-in senden`,
    p163:`Senden`,
    p164:`Fehler beim Laden der Buchung`,
    p165:`Check-in-Informationen`,
    p166:`Check-in-Anfrage senden`,
    p167:`Alle Buchungen`,
    p168:`Kommende Buchungen`,
    p169:`Stornierte Buchungen`,
    p170:`Gäste`,
    p171:`Check-in-Datum`,
    p172:`Check-in`,
    p173:`Gebucht`,
    p174:`Überbuchung`,
    p175:`Storniert`,
    p176:``,
    p177:``,
    p178:``,
    p179:``,
    p180:``,
    p181:``,
    p182:``,
    p183:``,
}
